export default __webpack_public_path__ + "static/media/profile_icon.db7d866a.svg";